import { Component, OnDestroy }  from '@angular/core';
import { ROUTER_DIRECTIVES } from '@angular/router';
import { IScenario, CreateScenarioRequest } from './scenario.service';

@Component({
    template: require('./scenario-create-results.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES]
})

export class ScenarioCreateResultsComponent implements OnDestroy {
    pageTitle:string = 'Create Scenario';
    currentScenario:IScenario;
    
    constructor(private request:CreateScenarioRequest){}

    ngOnDestroy(){
        this.request.destroySession();
    }
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-create-results.component.ts
 **/